<template>
	<div>我要招聘</div>
</template>

<script>
	export default {
		name: 'Hire',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
